import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { IFrenteTrabalhoForm } from './frente-trabalho-layout.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { ViaCepService } from '../../../services/viacep/viacep.service';
import { PermissionService } from '../../../services/permission.service';
import { HttpService } from '../../../services/common/http/common.http.service';
import { formatDateForInput2 } from '../../../utils/utility-functions';
import { format } from 'date-fns';

type IEtapas = 1 | 2;

type IOptions = {
  name: string;
  value: number | string;
  idPerfil?: number;
  email?: string;
  telefone?: string;
  funcionarioId?: number;
};

@Component({
  selector: 'app-frente-trabalho-layout',
  templateUrl: './frente-trabalho-layout.component.html',
  styleUrls: ['./frente-trabalho-layout.component.scss'],
})
export class FrenteTrabalhoLayoutComponent implements OnInit, AfterViewInit {
  permission: number = 2;
  editando: boolean = false;
  etapa: IEtapas = 1;
  totalEtapas: number = 2;
  loader: boolean = false;

  constructor(
    private router: Router,
    private toast: ToastrService,
    private activatedRoute: ActivatedRoute,
    private viaCepService: ViaCepService,
    private httpService: HttpService,
    private permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.permission = this.permissionService.getPermission();
    this.activateRoute();
    this.changeDetectorRef.detectChanges();
  }

  isMode: number = 1;
  disabledToEdit: boolean = false;
  form: IFrenteTrabalhoForm = {
    nomeFrenteDeTrabalho: '',
    proprietario: '',
    email: '',
    telefone: '',
    cep: '',
    rua: '',
    numeroLocal: '',
    cidade: '',
    encarregado: '',
    telefoneEncarregado: '',
    tipoFrenteDeTrabalho: 0,
    capacidadeFuncionarios: '',
    frenteTrabalhoId: 0,
    dataInicio: '',
    qtPrazo: 0,
  };
  disableButton: boolean = false;

  title: string = 'Cadastrar frente de trabalho';

  selectedEncarregado: IOptions = {
    name: '',
    value: '',
  };

  mockedSelectData = [
    {
      name: 'Alimentícia',
      value: 1,
    },
    {
      name: 'Construção',
      value: 2,
    },
    {
      name: 'Mecânica',
      value: 3,
    },
    {
      name: 'Automotivo',
      value: 4,
    },
  ];

  proprietarioOptions: IOptions[] = [
    {
      name: '',
      value: '',
      idPerfil: 0,
      email: '',
      telefone: '',
      funcionarioId: 0,
    },
  ];

  encarregadoOptions: IOptions[] = [
    {
      name: '',
      value: '',
      email: '',
    },
  ];

  ngAfterViewInit(): void {
    this.activateRoute();
    if (this.isMode == 2) {
      this.title = 'Editar frente de trabalho';
      this.disabledToEdit = true;
    }
  }

  proximaEtapa() {
    const form = this.form;
    if (form.nomeFrenteDeTrabalho && form.proprietario) {
      if (this.etapa < this.totalEtapas) {
        this.etapa++;
      }
    } else {
      Swal.fire({
        title: 'Atenção!',
        text: 'Preencha os campos obrigatórios antes de prosseguir.',
        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: 'green',
      });
    }

    this.onChangeSelect(this.form.encarregado);
  }

  etapaAnterior() {
    if (this.etapa > 0) {
      this.etapa--;
    }
  }

  onChangeSelect(event: any) {
    this.selectedEncarregado = this.findUser(this.encarregadoOptions, event);
    if (this.selectedEncarregado) {
      this.form.telefoneEncarregado = this.selectedEncarregado?.telefone ?? '';
    }
  }

  findUser(option: any, event: any) {
    const selectedUser = option.find((x: any) => x.value === Number(event));
    return selectedUser;
  }

  cadastrarFrenteDeTrabalho() {
    const payload = this.createPayload(this.form);
    const form = this.form;
    if (
      form.encarregado !== '0' &&
      form.tipoFrenteDeTrabalho !== '' &&
      form.capacidadeFuncionarios !== ''
    ) {
      if (this.isMode == 2) {
        this.httpService.usePut('UpdateFrenteTrabalho', payload).add(() => {
          this.router.navigate(['recursos-humanos/frente-de-trabalho']);
        });
      } else {
        this.httpService.usePost('CreateFrenteTrabalho', payload).add(() => {
          this.router.navigate(['recursos-humanos/frente-de-trabalho']);
        });
      }
    } else {
      Swal.fire({
        title: 'Atenção!',
        text: 'Preencha os campos obrigatórios antes de efetivar o cadastro.',
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor: 'green',
      });
    }
  }

  getFuncionarios() {
    this.encarregadoOptions = [];
    if (this.form.encarregado && this.form.encarregado !== 0) {
      this.httpService.useGet('FuncionarioByFilter').subscribe({
        next: (res: any) => {
          const encarregado = res.DataSet.find(
            (x: any) => x.FuncionarioId === this.form.encarregado
          );
          if (encarregado) {
            this.encarregadoOptions = [
              {
                name: encarregado.TxNome,
                value: encarregado.FuncionarioId,
                idPerfil: encarregado.PerfilId,
                funcionarioId: encarregado.FuncionarioId,
                telefone: encarregado.TxTeleFuncionario,
              } as IOptions,
            ];
          }
          this.buscarFuncionariosAdicionais();
        },
        error: (_error: any) => {
          this.loader = false;
          this.toast.error(
            'Não foi possível buscar o encarregado. Tente novamente!'
          );
        },
      });
    } else {
      this.buscarFuncionariosAdicionais();
    }
  }

  buscarFuncionariosAdicionais() {
    this.httpService.useGet('FuncionarioWithoutFrente').subscribe({
      next: (res: any) => {
        if (res.Funcionarios.length > 0) {
          const additionalOptions = res.Funcionarios.map((x: any) => {
            return {
              name: x.TxNomeFuncionario,
              value: x.IdFuncionario,
              idPerfil: x.PerfilId,
              funcionarioId: x.IdFuncionario,
              telefone: x.TxTelefoneFuncionario,
            } as IOptions;
          });

          const uniqueAdditionalOptions = additionalOptions.filter(
            (option: any) => {
              return !this.encarregadoOptions.some(
                (existingOption) => existingOption.value === option.value
              );
            }
          );

          this.encarregadoOptions = [
            ...this.encarregadoOptions,
            ...uniqueAdditionalOptions,
          ];
        }
        if (res.Funcionarios.length === 0 && this.isMode === undefined) {
          Swal.fire({
            title: 'Atenção',
            text: 'Não existem encarregados disponíveis para vincular a frente de trabalho',
            icon: 'warning',
            confirmButtonColor: 'green',
            confirmButtonText: 'Confirmar',
          }).then(() => {
            this.router.navigate(['recursos-humanos/frente-de-trabalho']);
          });
          return;
        }
      },
      error: (_error: any) => {
        this.loader = false;
        this.toast.error(
          'Não foi possível buscar os funcionários adicionais. Tente novamente!'
        );
      },
    });
  }

  validarEtapa1() {
    if (!this.form.nomeFrenteDeTrabalho || !this.form.proprietario) {
      return false;
    }
    return true;
  }

  validarEtapa2() {
    if (
      !this.form.encarregado ||
      !this.form.tipoFrenteDeTrabalho ||
      !this.form.capacidadeFuncionarios ||
      !this.form.dataInicio ||
      !this.form.qtPrazo
    ) {
      return false;
    }
    return true;
  }

  createPayload(form: IFrenteTrabalhoForm) {
    let data = null;

    data = this.form.dataInicio;
    
    const body = {
      TxCep: this.form.cep,
      NuResidencia: this.form.numeroLocal,
      TxTelefone: this.form.telefone,
      NuTipo: this.form.tipoFrenteDeTrabalho,
      NuCapacidade: Number(this.form.capacidadeFuncionarios),
      TxNome: this.form.nomeFrenteDeTrabalho,
      TxNomeProprietario: this.form.proprietario,
      TxEmail: this.form.email,
      TxEndereco: this.form.rua,
      TxCidade: this.form.cidade,
      FuncionarioId: this.selectedEncarregado.funcionarioId,
      IdFrenteTrabalho: this.form.frenteTrabalhoId,
      DtInicio: data,
      QtPrazo: this.form.qtPrazo,
    };
    return body;
  }

  convertToDate(dateString: string): Date {
    const [year, month, day] = dateString.split('-').map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      throw new Error('Data inválida');
    }
    return new Date(year, month - 1, day);
  }

  buscarCep() {
    this.loader = true;
    this.viaCepService.GetBuscarCep(this.form.cep, {
      onSuccess: (response: any) => {
        this.form.rua = response.logradouro;
        this.form.cidade = response.localidade;
        this.loader = false;
      },
      onError: (response: any) => {
        this.loader = false;
      },
    });
  }

  activateRoute() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.isMode = params['isMode'];
      if (params['isMode'] == 2) {
        const IdFrenteTrabalho = params['IdFrenteTrabalho'];
        this.loader = true;
        this.httpService
          .useGet('FrenteTrabalhoByFilter', { IdFrenteTrabalho })
          .subscribe({
            next: (res) => {
              const valueForm = res.DataSet[0];

              this.form.frenteTrabalhoId = valueForm.Id;
              this.form.nomeFrenteDeTrabalho = valueForm.Descricao ?? '';
              this.form.proprietario = valueForm.Proprietario ?? '';
              this.form.cidade = valueForm.Cidade ?? '';
              this.form.capacidadeFuncionarios = valueForm.Capacidade;
              this.form.telefone = valueForm.Telefone ?? '';
              this.form.cep = valueForm.Cep;
              this.form.email = valueForm.Email ?? '';
              this.form.rua = valueForm.Endereco ?? '';
              this.form.numeroLocal = valueForm.NuResidencia ?? '';
              this.form.dataInicio = String(valueForm.DtInicio).split('T')[0] ?? '';
              this.form.qtPrazo = valueForm.QtPrazo ?? 0;

              if (valueForm.IdEncarragado) {
                this.form.encarregado = valueForm.IdEncarragado;
              }

              this.getFuncionarios();
              this.onChangeSelect(this.form.encarregado);

              setTimeout(() => {
                this.form.tipoFrenteDeTrabalho =
                  Number(valueForm.TipoFrente) ?? 0;
              }, 100);
            },
            error: (err) => {},
            complete: () => {
              this.loader = false;
            },
          });
        return;
      }
      this.getFuncionarios();
    });
  }
}
